import * as i0 from '@angular/core';
import { SecurityContext, Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';

class NgxNl2brPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, sanitize = false) {
        if (typeof value !== 'string') {
            return value;
        }
        const result = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        return sanitize
            ? this.sanitizer.sanitize(SecurityContext.HTML, result) ?? ''
            : result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brPipe, name: "nl2br" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'nl2br',
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class NgxNl2brModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brModule, declarations: [NgxNl2brPipe], exports: [NgxNl2brPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.0.5", ngImport: i0, type: NgxNl2brModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgxNl2brPipe],
                    imports: [],
                    exports: [NgxNl2brPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NgxNl2brModule, NgxNl2brPipe };
